export const firebaseConfig = {
  apiKey: 'AIzaSyAdH-ObCjKMvYmzMq9g6zH8BnEyTOTx9i8',
  authDomain: 'bloggerly-8a431.firebaseapp.com',
  projectId: 'bloggerly-8a431',
  storageBucket: 'bloggerly-8a431.appspot.com',
  messagingSenderId: '1005155315229',
  appId: '1:1005155315229:web:20ac035eb7cf8adee160f4',
  measurementId: 'G-BBTLZF8LGD',
};
